export const getAccountTypeNameAndDescription = (name = "") => {
  let accountTypeName = name;
  let accountTypeDescription = "";
  const lowerCaseAccountTypeName = accountTypeName.toLowerCase();

  if (
    lowerCaseAccountTypeName.includes("lite") ||
    lowerCaseAccountTypeName.includes("classic")
  ) {
    accountTypeName = "CLASSIC";
    accountTypeDescription =
      "Spreads: The difference between the buy and sell prices in a trade";
  }
  if (
    lowerCaseAccountTypeName.includes("pro") ||
    lowerCaseAccountTypeName.includes("premium")
  ) {
    accountTypeName = "PREMIUM";
    accountTypeDescription =
      "Enhanced trading conditions";
  }
  if (lowerCaseAccountTypeName.includes("cent")) {
    accountTypeName = "CENT";
    accountTypeDescription = "Everything you need to start trading.";
  }
  return { accountTypeName, accountTypeDescription };
};

export const getAccountPlatformFromGroupName = (groupName) => {
  let accountPlatform = groupName;
  if (
    groupName.toLowerCase().includes("mt5") ||
    groupName.toLowerCase().includes("cent")
  ) {
    accountPlatform = "MT5";
  }

  if (groupName.toLowerCase().includes("mtt")) {
    accountPlatform = "MTT";
  }

  return accountPlatform;
};
